(() => {
  const sticky = document.querySelector('[data-mobile-sticky-atc]');
  if (!sticky) return;

  const productJsonEl = sticky.querySelector('[data-sticky-product-json]');
  if (!productJsonEl) return;

  const product = JSON.parse(productJsonEl.textContent);
  const sizeOptionIndex = Number(sticky.dataset.sizeOptionIndex);

  const sizeButtons = sticky.querySelectorAll('[data-sticky-size-button]');
  const addButton = sticky.querySelector('[data-sticky-atc-button]');
  const buttonText = sticky.querySelector('[data-sticky-button-text]');

  if (!addButton || !sizeButtons.length || Number.isNaN(sizeOptionIndex)) return;

  let selectedVariant = null;
  let isSyncingFromSticky = false;

  function getCartRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function getCurrentMainVariant() {
    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const currentVariantId = Number(variantInput?.value);

    return (
      product.variants.find((variant) => Number(variant.id) === currentVariantId) ||
      product.variants.find((variant) => variant.available) ||
      product.variants[0]
    );
  }

  function findVariantBySize(sizeValue) {
    const currentVariant = getCurrentMainVariant();
    if (!currentVariant) return null;

    const selectedOptions = [...currentVariant.options];

    selectedOptions[sizeOptionIndex] = sizeValue;

    return (
      product.variants.find((variant) => {
        return variant.options.every((optionValue, index) => {
          return optionValue === selectedOptions[index];
        });
      }) || null
    );
  }

  function updateMainVariantInput(variant) {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');

    isSyncingFromSticky = true;

    forms.forEach((form) => {
      const input = form.querySelector('[name="id"]');

      if (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    window.setTimeout(() => {
      isSyncingFromSticky = false;
    }, 300);
  }

  function setIdleState() {
    if (!selectedVariant) {
      addButton.disabled = true;
      if (buttonText) buttonText.textContent = 'Añadir';
      return;
    }

    if (!selectedVariant.available) {
      addButton.disabled = true;
      if (buttonText) buttonText.textContent = 'Agotado';
      return;
    }

    addButton.disabled = false;
    if (buttonText) buttonText.textContent = 'Añadir';
  }

  function clearSelection() {
    selectedVariant = null;

    sizeButtons.forEach((button) => {
      button.classList.remove('is-selected');
    });

    setIdleState();
  }

  function syncSizeAvailability() {
    let visibleAvailableSizes = 0;

    sizeButtons.forEach((button) => {
      const sizeValue = button.dataset.sizeValue;
      const variant = findVariantBySize(sizeValue);
      const isAvailable = Boolean(variant && variant.available);

      button.hidden = !isAvailable;
      button.disabled = !isAvailable;
      button.classList.toggle('is-hidden', !isAvailable);
      button.classList.toggle('is-disabled', !isAvailable);

      if (isAvailable) {
        visibleAvailableSizes += 1;
      }

      if (
        !isAvailable &&
        selectedVariant &&
        selectedVariant.options[sizeOptionIndex] === sizeValue
      ) {
        button.classList.remove('is-selected');
        selectedVariant = null;
      }
    });

    if (visibleAvailableSizes === 0) {
      addButton.disabled = true;
      if (buttonText) buttonText.textContent = 'Agotado';
      return;
    }

    setIdleState();
  }

  function findCartTarget() {
    return (
      document.querySelector('[href="/cart"]') ||
      document.querySelector('a[href*="/cart"]') ||
      document.querySelector('[data-cart-icon]') ||
      document.querySelector('[data-cart-count]') ||
      document.querySelector('.header__shopping-cart') ||
      document.querySelector('.cart-link') ||
      document.querySelector('.js-cart-link')
    );
  }

function runAddToCartAnimation() {
  const startRect = addButton.getBoundingClientRect();

  const flyer = document.createElement('div');

  flyer.className = 'mobile-sticky-atc__flyer';
  flyer.innerHTML = `
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 7h12l-1 13H7L6 7Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
      <path d="M9 7V6a3 3 0 0 1 6 0v1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    </svg>
  `;

  document.body.appendChild(flyer);

  const flyerSize = 42;

  const startX = startRect.left + startRect.width / 2 - flyerSize / 2;
  const startY = startRect.top + startRect.height / 2 - flyerSize / 2;

  // Destino fijo: esquina superior derecha mobile
  const endX = window.innerWidth - 34 - flyerSize / 2;
  const endY = 22;

  flyer.style.left = `${startX}px`;
  flyer.style.top = `${startY}px`;

  flyer.animate(
    [
      {
        transform: 'translate(0, 0) scale(1)',
        opacity: 1
      },
      {
        transform: `translate(${(endX - startX) * 0.45}px, -120px) scale(0.9)`,
        opacity: 0.95
      },
      {
        transform: `translate(${endX - startX}px, ${endY - startY}px) scale(0.25)`,
        opacity: 0
      }
    ],
    {
      duration: 760,
      easing: 'cubic-bezier(0.22, 0.75, 0.32, 1)'
    }
  ).onfinish = () => {
    flyer.remove();

    const cartTarget =
      document.querySelector('a[href*="/cart"]') ||
      document.querySelector('.header__shopping-cart') ||
      document.querySelector('.mobile-menu__cart-icon') ||
      document.querySelector('[data-cart-icon]') ||
      document.querySelector('[data-cart-count]');

    if (cartTarget) {
      cartTarget.classList.add('mobile-sticky-atc__cart-bump');

      window.setTimeout(() => {
        cartTarget.classList.remove('mobile-sticky-atc__cart-bump');
      }, 450);
    }
  };
}

  async function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('ajaxCart:updated', { bubbles: true }));

    try {
      const cartResponse = await fetch(`${getCartRoot()}cart.js`, {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();

      const countSelectors = [
        '[data-cart-count]',
        '.cart-count',
        '.js-cart-count',
        '.header__cart-count',
        '.cart-link__bubble'
      ];

      countSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          el.textContent = cart.item_count;
          el.classList.toggle('hide', cart.item_count === 0);
        });
      });
    } catch (error) {
      console.warn('[Sticky ATC] Cart refresh failed:', error);
    }
  }

  async function addSelectedVariantToCart() {
    if (!selectedVariant || !selectedVariant.available) {
      setIdleState();
      return;
    }

    addButton.disabled = true;
    if (buttonText) buttonText.textContent = 'Agregando…';

    const formData = new FormData();

    formData.append('id', String(selectedVariant.id));
    formData.append('quantity', '1');

    try {
      const response = await fetch(`${getCartRoot()}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('[Sticky ATC] Add to cart error:', data);
        throw new Error(data.description || data.message || 'No se pudo agregar al carrito');
      }

      runAddToCartAnimation();

      if (buttonText) buttonText.textContent = 'Agregado';

      await refreshCartUI();

      window.setTimeout(() => {
        setIdleState();
      }, 1800);
    } catch (error) {
      console.error('[Sticky ATC] Error:', error);

      if (buttonText) buttonText.textContent = 'Error';

      window.setTimeout(() => {
        setIdleState();
      }, 1800);
    }
  }

  sizeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.disabled || button.hidden) return;

      const sizeValue = button.dataset.sizeValue;
      const variant = findVariantBySize(sizeValue);

      if (!variant || !variant.available) {
        clearSelection();
        syncSizeAvailability();
        return;
      }

      selectedVariant = variant;

      sizeButtons.forEach((item) => {
        item.classList.toggle('is-selected', item === button);
      });

      updateMainVariantInput(variant);
      setIdleState();

      console.log('[Sticky ATC] Variante seleccionada:', variant.id, variant.title);
    });
  });

  addButton.addEventListener('click', addSelectedVariantToCart);

  document.addEventListener('change', (event) => {
    if (isSyncingFromSticky) return;

    const target = event.target;

    if (
      target.matches('input[name^="options"]') ||
      target.matches('select[name^="options"]') ||
      target.matches('[name="id"]')
    ) {
      clearSelection();

      window.setTimeout(() => {
        syncSizeAvailability();
      }, 100);
    }
  });

  syncSizeAvailability();
})();